import { Skeleton } from "@/components/ui/skeleton";
import { Card } from "@/components/ui/card";

export function BreakCompleteSkeleton() {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-md space-y-8">
        {/* Celebration Icon */}
        <div className="flex justify-center">
          <Skeleton className="h-24 w-24 rounded-full" />
        </div>

        {/* Header */}
        <div className="text-center space-y-2">
          <Skeleton className="h-8 w-56 mx-auto" />
          <Skeleton className="h-4 w-72 mx-auto" />
        </div>

        {/* Stats Card */}
        <Card className="p-6">
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-6 w-16" />
            </div>
            <div className="flex items-center justify-between">
              <Skeleton className="h-4 w-28" />
              <Skeleton className="h-6 w-20" />
            </div>
            <div className="flex items-center justify-between">
              <Skeleton className="h-4 w-20" />
              <Skeleton className="h-6 w-24" />
            </div>
          </div>
        </Card>

        {/* Rewards */}
        <div className="flex justify-center gap-4">
          <Skeleton className="h-16 w-24 rounded-xl" />
          <Skeleton className="h-16 w-24 rounded-xl" />
        </div>

        {/* Action Button */}
        <Skeleton className="h-14 w-full rounded-xl" />
      </div>
    </div>
  );
}
